define('nav-bar/nav-bar',['require','exports','module','durandal/app','knockout','nav-bar/nav-bar-store','plugins/router','router/router','web-urls','i18next','lodash','api-access','lib/auth/auth','mixpanel-helper','../analytics-popover/analytics-popover','../gsu-popover/gsu-popover','react-navbar','product-purchase-modal/product-purchase-modal','lib/multivariate-testing/multivariate-testing','popover-binder','knockout-bind-react'],function (require, exports, module) {
    var app = require('durandal/app');
    var ko = require('knockout');
    var navBarStore = require('nav-bar/nav-bar-store');
    var router = require('plugins/router');
    var routerModel = require('router/router');
    var webUrls = require('web-urls');
    var i18n = require('i18next');
    var _ = require('lodash');
    var apiAccess = require('api-access');
    var auth = require('lib/auth/auth');
    var mixpanelHelper = require('mixpanel-helper');
    var analyticsPopover = require('../analytics-popover/analytics-popover');
    var gsuPopover = require('../gsu-popover/gsu-popover');
    var ReactNavbar = require('react-navbar').default;
    var ProductPurchaseModal = require('product-purchase-modal/product-purchase-modal');
    var multivariateTesting = require('lib/multivariate-testing/multivariate-testing');

    require('popover-binder');
    require('knockout-bind-react');

    function header() {
        var self = this;

        self.reactOptions = ko.observable();
        self.isSideMenuSelected = ko.observable();

        app.on('sideMenu:shown', function () {
            self.isSideMenuSelected(true);
        });

        app.on('sideMenu:hidden', function () {
            self.isSideMenuSelected(false);
        });

        app.on('flags:updated', function (percent) {
            self.config(_.extend(self.config(), {
                percentage: percent
            }));
        });

        var showProductPurchaseModal = function () {
            mixpanelHelper.track('Buy Now link clicked: MFE');

            var buyNowUrl = webUrls.get('buyUpgradeUrl');

            multivariateTesting.checkVariation('inProductPurchaseTest')
                .then(function (variation) {
                    if (variation === 'variation-a') {
                        ProductPurchaseModal.show({
                            props: {
                                initialPage: 'plan-form'
                            }
                        });
                    } else {
                        window.open(buyNowUrl, '_self');
                    }
                })
                .fail(function () {
                    window.open(buyNowUrl, '_self');
                });
        };

        self.config = ko.observable();

        self.reactOptions = ko.computed(function () {
            if (self.config()) {
                var routeHash = router.activeInstruction && router.activeInstruction().config.hash;
                var routeId = router.activeInstruction && router.activeInstruction().config.id;
                var isSetupFlow = routeHash === '#setup' || routeHash === '#setup-error';
                var isMeetingsRoute = routeId === 'meetings';

                // for MFE if the user is not authenticated we are restricting navigation... also during the setup flow
                var restrictNavigation = !self.config().isAuthenticated || isSetupFlow;
                var currentMenuItem = routeHash || '';

                var props = ReactNavbar.configureG2m(
                    _.extend(self.config(), {
                        restrictNavigation: restrictNavigation,
                        currentMenuItem: currentMenuItem,
                        locale: i18n.lng(),
                        messageAction: showProductPurchaseModal,
                        progress: {
                            isProgressVisible: isMeetingsRoute && self.config().isProgressVisible,
                            percentage: self.config().percentage,
                            isSelected: self.isSideMenuSelected(),
                            onProgressClick: function () { app.trigger('progress:clicked') }
                        },
                        onMenuClicked: function () { app.trigger('navbar:menu-clicked') },
                        signoutCallback: function (e) {
                            auth.logout();

                            // Do not navigate to the href link if there is one.
                            // Let the auth function handle any navigation.
                            e.preventDefault();
                        }
                    }),
                    webUrls,
                    i18n.t,
                    mixpanelHelper
                );

                return {
                    component: ReactNavbar,
                    props: props,
                    callback: function (componentInstance) {
                        routerModel.navBar = componentInstance;
                    }
                };
            }
            return undefined;
        });

        self.attached = function () {
            if (auth.getToken()) {
                navBarStore.quickFetch().then(function (config) {
                    self.config(config);
                });

                navBarStore.fetch().then(function (config) {
                    self.config(config);
                    if (config.setSaleEntitled && config.setSaleProvisioned) {
                        analyticsPopover.show();
                    } else {
                        gsuPopover.show();
                    }
                });

                app.on('GSU:Enabled', function () {
                    /**
                     * A bug exists in api-access where multiple GET requests made in sequence around a PUT request
                     * causes the cache to get stale.
                     *
                     * Clear the cache before the user settings request as a workaround.
                     */
                    apiAccess.cors.clearCache();

                    navBarStore.fetch().then(function (config) {
                        self.config(config);
                    });
                });
            } else {
                self.config({isAuthenticated: false});
            }
        };
    }

    module.exports = header;
});

